import React, { FC } from 'react'
import { useStoreState } from 'store'

export const ShimmerRow: FC = () => {
  const flags = useStoreState(state => state.featureFlags.flags)
  const hideUpfrontCosts = flags['hideUpfrontCosts']

  return (
    <>
      <tr className="rate-table__row" data-testid="shimmer-row">
        <td className="column__full">
          <div className="rate-table__offer-content">
            <div className="ShimmerBox p-4 mt-1">
              <div className="ShimmerBox-compactWrap shimmer-row__top_left"></div>
            </div>
          </div>
          <div className="ShimmerBox mt-1 sm:display-none">
            <div className="ShimmerBox-compactWrap mt-1 shimmer-row__top_right"></div>
          </div>
        </td>
        <td className="column__flex" data-heading="Rate">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        <td className="column__flex" data-heading="APR">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        {!hideUpfrontCosts && (
          <td className="column__flex" data-heading="Upfront costs">
            <div className="ShimmerBox p-4">
              <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
            </div>
          </td>
        )}
        <td className="column__flex" data-heading="Mo. payment">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        <td className="column__full">
          <div className="ShimmerBox p-4 mt-1 w:1/2">
            <div className="ShimmerBox-compactWrap"></div>
          </div>
          <div className="ShimmerBox p-4 mt-1 sm:display-none w:1/2">
            <div className="ShimmerBox-compactWrap"></div>
          </div>
        </td>
      </tr>
      <tr className="rate-table__row">
        <td className="column__full">
          <div className="rate-table__offer-content">
            <div className="ShimmerBox p-4 mt-1">
              <div className="ShimmerBox-compactWrap shimmer-row__top_left"></div>
            </div>
          </div>
          <div className="ShimmerBox mt-1 sm:display-none">
            <div className="ShimmerBox-compactWrap mt-1 shimmer-row__top_right"></div>
          </div>
        </td>
        <td className="column__flex" data-heading="Rate">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        <td className="column__flex" data-heading="APR">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        {!hideUpfrontCosts && (
          <td className="column__flex" data-heading="Upfront costs">
            <div className="ShimmerBox p-4">
              <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
            </div>
          </td>
        )}
        <td className="column__flex" data-heading="Mo. payment">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        <td className="column__full">
          <div className="ShimmerBox p-4 mt-1 w:1/2">
            <div className="ShimmerBox-compactWrap"></div>
          </div>
          <div className="ShimmerBox p-4 mt-1 sm:display-none w:1/2">
            <div className="ShimmerBox-compactWrap"></div>
          </div>
        </td>
      </tr>
      <tr className="rate-table__row">
        <td className="column__full">
          <div className="rate-table__offer-content">
            <div className="ShimmerBox p-4 mt-1">
              <div className="ShimmerBox-compactWrap shimmer-row__top_left"></div>
            </div>
          </div>
          <div className="ShimmerBox mt-1 sm:display-none">
            <div className="ShimmerBox-compactWrap mt-1 shimmer-row__top_right"></div>
          </div>
        </td>
        <td className="column__flex" data-heading="Rate">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        <td className="column__flex" data-heading="APR">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        {!hideUpfrontCosts && (
          <td className="column__flex" data-heading="Upfront costs">
            <div className="ShimmerBox p-4">
              <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
            </div>
          </td>
        )}
        <td className="column__flex" data-heading="Mo. payment">
          <div className="ShimmerBox p-4">
            <p className="ShimmerBox-compactWrap shimmer-row_offer"></p>
          </div>
        </td>
        <td className="column__full">
          <div className="ShimmerBox p-4 mt-1 w:1/2">
            <div className="ShimmerBox-compactWrap"></div>
          </div>
          <div className="ShimmerBox p-4 mt-1 sm:display-none w:1/2">
            <div className="ShimmerBox-compactWrap"></div>
          </div>
        </td>
      </tr>
    </>
  )
}
